import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CalloutColor, CalloutPlacement } from '@freelancer/ui/callout';
import { IconColor, IconSize } from '@freelancer/ui/icon';
import {
  LinkColor,
  LinkIconPosition,
  LinkUnderline,
  LinkWeight,
} from '@freelancer/ui/link';
import { LogoSize } from '@freelancer/ui/logo';
import { FontColor, FontWeight, TextSize } from '@freelancer/ui/text';

@Component({
  selector: 'app-navigation-logged-out-home-section-solutions',
  template: `
    <fl-callout
      class="Callout"
      [hover]="true"
      [edgeToEdge]="true"
      [color]="CalloutColor.DARK"
      [hideCloseButton]="true"
      [hideArrow]="true"
      [crawlable]="true"
      [placement]="CalloutPlacement.BOTTOM_RIGHT"
      [overflowContent]="true"
      (calloutOpen)="openCalloutHandler()"
      (calloutClose)="closeCalloutHandler()"
    >
      <fl-callout-trigger class="Callout">
        <fl-link
          class="NavigationItem"
          flTrackingLabel="Solutions"
          i18n="Navigation solutions label"
          [class.IsCalloutOpen]="isCalloutOpen"
          [flHideMobile]="true"
          [iconName]="'ui-chevron-down'"
          [iconColor]="IconColor.INHERIT"
          [iconPosition]="LinkIconPosition.RIGHT"
          [size]="TextSize.SMALL"
          [flMarginRight]="'small'"
          [color]="LinkColor.LIGHT"
          [underline]="LinkUnderline.NEVER"
        >
          Solutions
        </fl-link>
      </fl-callout-trigger>

      <fl-callout-content>
        <div class="Container">
          <div class="NavContainer">
            <fl-grid class="GridNavContainer">
              <fl-col [col]="6">
                <app-navigation-logged-out-home-nav-item
                  class="CardLink"
                  i18n-titleLink="Enterprise navigation item title text"
                  titleLink="Enterprise"
                  i18n-description="Enterprise navigation item description text"
                  description="Power your competitive advantage with Freelancer Enterprise."
                  [doubleColumn]="true"
                  [iconColor]="IconColor.INHERIT"
                  [iconName]="'ui-language'"
                  [iconArrow]="false"
                  [isActive]="true"
                  [flMarginBottom]="'mid'"
                  [url]="'/enterprise'"
                ></app-navigation-logged-out-home-nav-item>
                <app-navigation-logged-out-home-nav-item
                  class="CardLink"
                  i18n-titleLink="Field Services navigation item title text"
                  titleLink="Field Services"
                  i18n-description="
                    Field Services navigation item description text
                  "
                  description="Deliver expertise anywhere in the world at scale - on demand."
                  [doubleColumn]="true"
                  [iconArrow]="false"
                  [isActive]="true"
                  [iconName]="'ui-handyman'"
                  [iconColor]="IconColor.WARNING"
                  [flMarginBottom]="'mid'"
                  [url]="'/globalfleet'"
                ></app-navigation-logged-out-home-nav-item>
                <app-navigation-logged-out-home-nav-item
                  class="CardLink"
                  i18n-titleLink="AI business navigation item title text"
                  titleLink="AI for business"
                  i18n-description="
                    AI business navigation item description text
                  "
                  description="Let experts in the latest AI technology transform your business."
                  [iconColor]="IconColor.INHERIT"
                  [doubleColumn]="true"
                  [iconArrow]="false"
                  [isActive]="true"
                  [url]="'/ai-for-business'"
                  [useIconFont]="false"
                  [iconName]="'ui-ai'"
                  [flMarginBottom]="'xlarge'"
                ></app-navigation-logged-out-home-nav-item>
                <div
                  class="ColHeader"
                  [flMarginBottom]="'small'"
                >
                  <fl-logo
                    [size]="LogoSize.MINI"
                    [flMarginRight]="'xxxsmall'"
                  ></fl-logo>
                  <fl-text
                    i18n="Freelancer products header"
                    [color]="FontColor.LIGHT"
                    [weight]="FontWeight.BOLD"
                  >
                    Freelancer products
                  </fl-text>
                </div>
                <app-navigation-logged-out-home-section-products></app-navigation-logged-out-home-section-products>
              </fl-col>
              <fl-col [col]="6">
                <app-navigation-logged-out-home-nav-item
                  class="CardLink"
                  i18n-titleLink="Government navigation item title text"
                  titleLink="Government"
                  i18n-description="Government navigation item description text"
                  description="Solve critical national challenges by crowdsourcing innovative solutions."
                  [doubleColumn]="true"
                  [iconName]="'ui-bank'"
                  [iconColor]="IconColor.RECRUITER_LIGHT"
                  [iconArrow]="false"
                  [isActive]="true"
                  [url]="'/enterprise'"
                  [flMarginBottom]="'mid'"
                ></app-navigation-logged-out-home-nav-item>
                <app-navigation-logged-out-home-nav-item
                  class="CardLink"
                  i18n-titleLink="Freelancer API navigation item title text"
                  titleLink="Freelancer API"
                  i18n-description="
                    Freelancer API navigation item description text
                  "
                  description="Use the Freelancer API to access a cloud workforce of skilled freelancers."
                  [doubleColumn]="true"
                  [iconArrow]="false"
                  [isActive]="true"
                  [iconName]="'ui-api'"
                  [iconColor]="IconColor.CONTEST"
                  [url]="'https://developers.freelancer.com/'"
                  [flMarginBottom]="'mid'"
                ></app-navigation-logged-out-home-nav-item>
                <app-navigation-logged-out-home-nav-item
                  class="CardLink"
                  i18n-titleLink="Local jobs navigation item title text"
                  titleLink="Local jobs"
                  i18n-description="Local jobs navigation item description text"
                  description="Get help in any location, anywhere in the world."
                  [doubleColumn]="true"
                  [iconArrow]="false"
                  [isActive]="true"
                  [url]="'/local'"
                  [iconColor]="IconColor.SUCCESS"
                  [iconName]="'ui-pin-drop'"
                  [flMarginBottom]="'xlarge'"
                ></app-navigation-logged-out-home-nav-item>
                <div
                  class="ColHeader"
                  [flMarginBottom]="'small'"
                >
                  <fl-logo
                    [size]="LogoSize.MINI"
                    [flMarginRight]="'xxxsmall'"
                  ></fl-logo>
                  <fl-text
                    i18n="Freelancer services header"
                    [color]="FontColor.LIGHT"
                    [weight]="FontWeight.BOLD"
                  >
                    Freelancer services
                  </fl-text>
                </div>
                <app-navigation-logged-out-home-section-services>
                </app-navigation-logged-out-home-section-services>
              </fl-col>
            </fl-grid>
          </div>
          <div class="PannelContainer">
            <fl-text
              i18n="How it works title card"
              [color]="FontColor.LIGHT"
              [weight]="FontWeight.BOLD"
              [flMarginBottom]="'mid'"
            >
              How it works
            </fl-text>
            <fl-grid class="GridSideContainer">
              <fl-col [col]="6">
                <app-navigation-logged-out-home-card
                  [url]="
                    '/articles/starting-your-business/finding-the-best-freelancer'
                  "
                  [imgSrc]="'logged-out-navigation/solutions/solutions-1.png'"
                  [description]="
                    'How to hire the perfect freelancer for your project'
                  "
                  [readMore]="true"
                  [longDescription]="true"
                  [flMarginBottom]="'mid'"
                >
                </app-navigation-logged-out-home-card>
                <div
                  class="ColHeader"
                  [flMarginBottom]="'small'"
                >
                  <fl-icon
                    class="ViewMoreColor"
                    [flMarginRight]="'xxsmall'"
                    [name]="'ui-lightbulb'"
                    [useIconFont]="true"
                    [fillIconFont]="false"
                    [color]="IconColor.INHERIT"
                    [size]="IconSize.XSMALL"
                  ></fl-icon>

                  <fl-text
                    i18n="Get ideas header"
                    [color]="FontColor.LIGHT"
                    [weight]="FontWeight.BOLD"
                  >
                    Get ideas
                  </fl-text>
                </div>
                <div class="LinksColumn">
                  <app-navigation-logged-out-home-section-get-ideas
                    class="GetIdeas"
                  ></app-navigation-logged-out-home-section-get-ideas>
                  <fl-link
                    flTrackingLabel="ViewAllClick"
                    i18n="View all link"
                    class="ViewMoreColor"
                    [link]="'/discover'"
                    [iconName]="'ui-chevron-right'"
                    [iconPosition]="LinkIconPosition.RIGHT"
                    [weight]="LinkWeight.MEDIUM"
                    [color]="LinkColor.INHERIT"
                    [iconColor]="IconColor.INHERIT"
                    [iconAnimation]="true"
                  >
                    View all
                  </fl-link>
                </div>
              </fl-col>
              <fl-col [col]="6">
                <app-navigation-logged-out-home-card
                  [url]="
                    '/community/articles/how-to-earn-money-at-freelancer-com'
                  "
                  [imgSrc]="'logged-out-navigation/solutions/solutions-2.png'"
                  [description]="'How to get started earning money freelancing'"
                  [readMore]="true"
                  [longDescription]="true"
                  [flMarginBottom]="'mid'"
                >
                </app-navigation-logged-out-home-card>

                <div
                  class="ColHeader"
                  [flMarginBottom]="'small'"
                >
                  <fl-icon
                    class="ViewMoreColor"
                    [flMarginRight]="'xxsmall'"
                    [name]="'ui-book'"
                    [useIconFont]="true"
                    [fillIconFont]="false"
                    [color]="IconColor.INHERIT"
                    [size]="IconSize.XSMALL"
                  ></fl-icon>
                  <fl-text
                    i18n="Resources header"
                    [color]="FontColor.LIGHT"
                    [weight]="FontWeight.BOLD"
                  >
                    Resources
                  </fl-text>
                </div>
                <app-navigation-logged-out-home-section-resources
                  class="Resources"
                ></app-navigation-logged-out-home-section-resources>
                <fl-link
                  flTrackingLabel="ViewAllClick"
                  i18n="View all link"
                  class="ViewMoreColor"
                  [link]="'/articles'"
                  [iconName]="'ui-chevron-right'"
                  [iconPosition]="LinkIconPosition.RIGHT"
                  [weight]="LinkWeight.MEDIUM"
                  [color]="LinkColor.INHERIT"
                  [iconColor]="IconColor.INHERIT"
                  [iconAnimation]="true"
                >
                  View all
                </fl-link>
              </fl-col>
            </fl-grid>
          </div>
        </div>
      </fl-callout-content>
    </fl-callout>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./navigation-logged-out-home-section-solutions.component.scss'],
})
export class NavigationLoggedOutHomeSectionSolutionsComponent {
  CalloutPlacement = CalloutPlacement;
  CalloutColor = CalloutColor;
  FontWeight = FontWeight;
  FontColor = FontColor;
  IconColor = IconColor;
  IconSize = IconSize;
  LinkColor = LinkColor;
  LinkIconPosition = LinkIconPosition;
  LinkWeight = LinkWeight;
  LinkUnderline = LinkUnderline;
  LogoSize = LogoSize;
  TextSize = TextSize;

  isCalloutOpen = false;

  openCalloutHandler(): void {
    this.isCalloutOpen = true;
  }

  closeCalloutHandler(): void {
    this.isCalloutOpen = false;
  }
}
